<template>
  <v-autocomplete
    v-model="selectedCustomer"
    :items="availableCustomerList"
    :loading="isLoading"
    :disabled="disabled"
    :search-input.sync="customerSearch"
    item-text="selectorText"
    return-object
    no-filter
    clearable
    outlined
    dense
    hide-details="auto"
    label="Cliente o CIF"
    prepend-inner-icon="mdi-account-outline"
    no-data-text="No hay clientes que coincidan"
    @focus="loadCustomerList('')"
    @change="$emit('select', $event || null)"
  ></v-autocomplete>
</template>

<script>
import { ApiCustomerRepository } from './ApiCustomerRepository';

export default {
  name: 'CustomerAutocomplete',
  props: {
    companyId: { type: Number, required: true },
    customerTaxId: { type: String, default: '' },
    customerName: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      customerRepository: new ApiCustomerRepository(),
      customerItemList: [],
      selectedCustomer: null,
      customerSearch: '',
      customerSearchTimer: null,
      requestNumber: 0,
      isLoading: false,
    };
  },
  computed: {
    availableCustomerList() {
      if (!this.selectedCustomer) return this.customerItemList;
      return this.customerItemList.some(customer => customer.id === this.selectedCustomer.id)
        ? this.customerItemList
        : [this.selectedCustomer].concat(this.customerItemList);
    },
  },
  watch: {
    customerTaxId: { immediate: true, handler() { this.syncSelectedCustomer(); } },
    customerName: { immediate: true, handler() { this.syncSelectedCustomer(); } },
    customerSearch(searchTerm) {
      if (this.selectedCustomer && searchTerm === this.selectedCustomer.selectorText) return;
      if (this.customerSearchTimer) clearTimeout(this.customerSearchTimer);
      this.customerSearchTimer = setTimeout(() => this.loadCustomerList(searchTerm), 300);
    },
  },
  beforeDestroy() {
    if (this.customerSearchTimer) clearTimeout(this.customerSearchTimer);
  },
  methods: {
    syncSelectedCustomer() {
      if (!this.customerTaxId && !this.customerName) {
        this.selectedCustomer = null;
        return;
      }
      this.selectedCustomer = {
        id: null,
        cif: this.customerTaxId,
        name: this.customerName,
        selectorText: [this.customerTaxId, this.customerName].filter(Boolean).join(' - '),
      };
    },
    async loadCustomerList(searchTerm) {
      const requestNumber = this.requestNumber + 1;
      this.requestNumber = requestNumber;
      this.isLoading = true;
      try {
        const customerList = await this.customerRepository.search(
          this.companyId,
          String(searchTerm || '').trim(),
        );
        if (requestNumber !== this.requestNumber) return;
        this.customerItemList = customerList;
      } catch (error) {
        console.error('Customer search failed:', error);
        if (requestNumber === this.requestNumber) this.customerItemList = [];
      } finally {
        if (requestNumber === this.requestNumber) this.isLoading = false;
      }
    },
  },
};
</script>
